import axios from 'axios'
import { clearAuth, getAuthToken } from './auth'
import { BASE_URL } from './config'

const AUTH_ERROR_PATTERNS = [
  'session expired',
  'invalid token',
  'token expired',
  'unauthorized',
  'authorised',
  'forbidden',
  'login again'
]

const isAuthErrorMessage = (value) => {
  if (!value || typeof value !== 'string') return false
  const normalized = value.toLowerCase()
  return AUTH_ERROR_PATTERNS.some((pattern) => normalized.includes(pattern))
}

const redirectToLogin = () => {
  if (typeof window === 'undefined') return
  const currentPath = `${window.location.pathname || ''}${window.location.search || ''}${window.location.hash || ''}`
  if ((window.location.pathname || '') === '/login') return
  clearAuth()
  const redirect = currentPath && currentPath !== '/' ? `?redirect=${encodeURIComponent(currentPath)}` : ''
  window.location.assign(`/login${redirect}`)
}

const createApiClient = () => {
  const apiClient = axios.create({
    baseURL: BASE_URL,
    headers: {
      Authorization: 'Basic ' + btoa('amplify:amplify')
    }
  })

  apiClient.interceptors.request.use((config) => {
    const token = getAuthToken()
    config.headers = config.headers || {}
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    } else if (!config.headers.Authorization) {
      config.headers.Authorization = 'Basic ' + btoa('amplify:amplify')
    }
    return config
  })

  apiClient.interceptors.response.use(
    (response) => {
      const data = response?.data || {}
      const statusCode = response?.status
      const authLikeStatus = data?.status === 401 || data?.status === 403
      const authLikeMessage =
        isAuthErrorMessage(data?.msg) ||
        isAuthErrorMessage(data?.message) ||
        isAuthErrorMessage(data?.error)

      if (statusCode === 401 || statusCode === 403 || authLikeStatus || authLikeMessage) {
        redirectToLogin()
      }

      return response
    },
    (error) => {
      const statusCode = error?.response?.status
      const data = error?.response?.data || {}
      const authLikeStatus = data?.status === 401 || data?.status === 403
      const authLikeMessage =
        isAuthErrorMessage(data?.msg) ||
        isAuthErrorMessage(data?.message) ||
        isAuthErrorMessage(data?.error)

      if (statusCode === 401 || statusCode === 403 || authLikeStatus || authLikeMessage) {
        redirectToLogin()
      }

      return Promise.reject(error)
    }
  )

  return apiClient
}

export default createApiClient
